import {Component, HostListener, OnInit} from '@angular/core';
import {AnalyticsService} from './analytics.service';
// import {Color, SingleDataSet, Label, monkeyPatchChartJsLegend, monkeyPatchChartJsTooltip} from 'ng2-charts';
import {Game} from '../models/game';
import {Arena} from '../models/arena';
import {FormBuilder, FormGroup} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
// import {ChartOptions, ChartType,} from 'chart.js';
import {Analytic} from '../models/analytic';
import {AuthenticationService} from '../dashboard-login/authentication.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {
  public is_admin;
  public arenas;
  public tournaments;
  public games;
  public events;
  public nAData; // not admin data
  // public pieChartLabels: Label[];
  // public pieChartData: SingleDataSet;
  // public pieChartType: ChartType = 'pie';
  public pieChartPlugins = [];
  public pieChartLegend = true;
  public chartReady: boolean;
  public numbers: Analytic;
  // public gameBarChartOptions: RadialChartOptions = {
  //   responsive: true
  // };
  // public gameBarChartLabels: Label[];
  // public gameBarChartData: ChartDataSets[] = [];
  // public gameBarChartType: ChartType = 'bar';
  public gameBarChartLegend = true;
  public gameBarChartReady: boolean;
  dataForm: FormGroup;
  public types;
  public submitButton;
  public selectedGames = [];
  public beginDate;
  public endDate;
  public countriesLimit = 10;
  public showButton = 'Show More';
  // public pieChartOptions: ChartOptions = {
  //   responsive: true,
  //   plugins: {
  //   }
  // };
  public error;
  public trunclimit = '20';
  public spinner = false;

  constructor(public authenticationService: AuthenticationService, private analyticsService: AnalyticsService, private fb: FormBuilder, private router: Router, private route: ActivatedRoute) {
    // monkeyPatchChartJsTooltip();
    // monkeyPatchChartJsLegend();
    this.submitButton = 'Submit';

    this.chartReady = false;
    this.types = [{name: 'None', value: ''}, {name: 'Single', value: 'single'}, {
      name: 'Team',
      value: 'team'
    }, {name: 'Both', value: 'single.team'}];
    // this.beginDate = moment().subtract(1, 'days')
    // this.endDate = moment();
    this.dataForm = this.fb.group({
      date: [{begin: this.beginDate, end: this.endDate}],
      arena_countries: [false],
      with_event: [false],
      tournament: [null],
      game: [''],
      type: [null],
      arena: [null],
      event: [null]
    });

  }

  ngOnInit() {
    this.spinner = true;
    this.analyticsService.getAuthorization().subscribe(
      data => {
        if (data.authority == 'GBarenaAdmin') {
          this.is_admin = true;
        }
        this.nAData = data;
      }
    );
    this.analyticsService.getGames().subscribe(
      data => {
        this.games = data.data;
      }
    );
    this.analyticsService.getArenas().subscribe(
      data => {
        this.arenas = data;
      }
    );
    this.analyticsService.getEvents().subscribe(
      data => {
        this.events = data.data;
      }
    );
    this.analyticsService.getTournaments().subscribe(
      tournaments => {
        this.tournaments = tournaments;

      }
    );
    let startingDate: any = this.route.snapshot.queryParamMap.get('from') ? this.route.snapshot.queryParamMap.get('from') : this.dataForm.value.date.begin.unix();
    let endingDate: any = this.route.snapshot.queryParamMap.get('to') ? this.route.snapshot.queryParamMap.get('to') : this.dataForm.value.date.end.unix();
    let arena_countries = (this.route.snapshot.queryParamMap.get('arena_countries') == 'true');
    let with_event = (this.route.snapshot.queryParamMap.get('with_event') == 'true');
    let game = this.route.snapshot.queryParamMap.get('game') ? this.route.snapshot.queryParamMap.get('game') : '';
    let tournament = this.route.snapshot.queryParamMap.get('tournament');
    let type = this.route.snapshot.queryParamMap.get('type') ? this.route.snapshot.queryParamMap.get('type') : null;
    let arena = this.route.snapshot.queryParamMap.get('arena') ? this.route.snapshot.queryParamMap.get('arena') : null;
    let event = this.route.snapshot.queryParamMap.get('event') ? this.route.snapshot.queryParamMap.get('event') : null;
    let games = (game != '') ? game.split('.') : null;
    this.dataForm.setValue({
      date: {
        begin: new Date(startingDate * 1000),
        end: new Date(endingDate * 1000)
      },
      arena_countries: arena_countries,
      with_event: with_event,
      type: type,
      arena: arena,
      event: event,
      tournament: tournament,
      game: games
    });
    this.analyticsService.getAnalytics(startingDate, endingDate, arena_countries, with_event, game, tournament, type, arena, event).subscribe(
      data => {
        this.numbers = data;
        this.spinner = false;
        if (games) {
          let gamesChip = [];
          for (let game of games) {
            gamesChip.push(this.games.find(x => x.code == game).name);
          }
          this.selectedGames = gamesChip;
        }
        if (data.countries) {
          if (+data.countries.length > 0) {
            let topCountries = [];
            let topParticipations = [];
            for (let i = 0; i < 9; i++) {
              topCountries.push(data.countries[i].name);
              topParticipations.push(data.countries[i].participations_count);
            }
            //
            // this.pieChartLabels = topCountries;
            // this.pieChartData = topParticipations;
            this.chartReady = true;
          }
        }
        if (this.numbers.games) {
          let data = [];
          for (let i = 0; i < 9; i++) {
            if (this.numbers.games[i]) {
              data.push({
                data: [this.numbers.games[i].new_participants,
                  this.numbers.games[i].old_participants, this.numbers.games[i].total_participants, this.numbers.games[i].total_participation,],
                label: this.numbers.games[i].code
              });
            } else {
              break;
            }
          }
          // this.gameBarChartLabels = ['New Participants', 'Old Participants', 'Total Participants', 'Total Participantion'];
          // this.gameBarChartData = data;
          this.gameBarChartReady = true;
        }
      },
      error => this.error = error.error.message
    );

  }

  onSubmit(form) {
    this.spinner = true;
    this.submitButton = 'Submitting';
    let startingDate = form.value.date ? form.value.date.begin.unix() : null;
    let endingDate = form.value.date ? form.value.date.end.unix() : null;
    let arena_countries = form.value.arena_countries ? true : false;
    let with_event = form.value.with_event ? true : false;
    let games = form.value.game;
    let tournament = (form.value.tournament == null) ? '' : form.value.tournament;
    let type = form.value.type;
    let event = form.value.event;
    let arena = form.value.arena;
    var gamesString = '';
    if (games) {
      for (let game of games) {
        gamesString += game + '.';
      }
    }
    gamesString = gamesString.slice(0, -1);
    let queryParams = {
      'arena_countries': arena_countries,
      'with_event': with_event
    };
    if (startingDate != null) {
      Object.assign(queryParams, {'from': startingDate});
    }
    if (endingDate != null) {
      Object.assign(queryParams, {'to': endingDate});
    }
    if (gamesString != '') {
      Object.assign(queryParams, {'game': gamesString});
    }
    if (tournament != '') {
      Object.assign(queryParams, {'tournament': tournament});
    }
    if (type != '') {
      Object.assign(queryParams, {'type': type});
    }
    if (arena != '') {
      Object.assign(queryParams, {'arena': arena});
    }
    if (event != '') {
      Object.assign(queryParams, {'event': event});
    }
    this.router.navigate(['/dashboard'], {
      queryParams: queryParams
    });
    this.analyticsService.getAnalytics(startingDate, endingDate, arena_countries, with_event, gamesString, tournament, type, arena, event).subscribe(
      data => {
        this.numbers = data;
        if (this.numbers.countries) {
          if (+this.numbers.countries.length > 0) {
            let topCountries = [];
            let topParticipations = [];
            for (let i = 0; i < 9; i++) {
              topCountries.push(this.numbers.countries[i].name);
              topParticipations.push(this.numbers.countries[i].participations_count);
            }
            // this.pieChartLabels = topCountries;
            // this.pieChartData = topParticipations;
            this.chartReady = true;
          }
        }
        if (this.numbers.games) {
          let data = [];
          for (let i = 0; i < 9; i++) {
            if (this.numbers.games[i]) {
              data.push({
                data: [this.numbers.games[i].total_participation, this.numbers.games[i].new_participants,
                  this.numbers.games[i].old_participants, this.numbers.games[i].total_participants],
                label: this.numbers.games[i].code
              });
            } else {
              break;
            }
          }
          // this.gameBarChartLabels = ['Total Participation', 'New Participants', 'Old Participants', 'Total Participants'];
          // this.gameBarChartData = data;
          this.gameBarChartReady = true;
        }

        this.submitButton = 'Submit';
        this.spinner = false;
      },
      error => this.error = error.error.message
    );
  }


  selectGame(event) {
    let games = [];
    for (let game of event.value) {
      games.push(this.games.find(x => x.code == game).name);
    }
    this.selectedGames = games;

  }

  removeGame(game) {
    const index: number = this.selectedGames.indexOf(game);
    if (index !== -1) {
      this.selectedGames.splice(index, 1);
    }
    let games = [];
    for (let game of this.selectedGames) {
      games.push(this.games.find(x => x.name == game).code);
    }
    this.dataForm.controls['game'].setValue(games);
  }

  showAllCountries() {
    if (this.showButton == 'Show More') {
      this.countriesLimit = 100;
      this.showButton = 'Show Less';
    } else {
      this.countriesLimit = 10;
      this.showButton = 'Show More';
    }
  }

  logged() {
    return this.authenticationService.loggedIn();
  }

}
